import { fromSeconds } from '@/ui';
import { getMetricsStatusLabel, metricsStatusOrder } from './metricsStatusMeta';
import type { MetricsApiDto, MetricsDto } from './metricsHelpers';

const formatMetricsRangeLabel = (value: string): string => {
  const [year, month, day] = value.split('-');
  if (!year || !month || !day) return value;
  if (year.length !== 4 || month.length !== 2 || day.length !== 2) return value;
  return `${day}/${month}/${year}`;
};

export const metricsApiToDto = (api: MetricsApiDto): MetricsDto => {
  const statusMetrics = metricsStatusOrder.map((key) => {
    const metric = api.statusMetrics.find((item) => item.key === key);
    return {
      key,
      label: getMetricsStatusLabel(key),
      count: metric?.count ?? 0,
      percentage: metric?.percentage ?? 0,
    };
  });
  const statusSummary = api.statusSummary;

  return {
    metricsRangeLabel: api.metricsRangeLabel,
    metricsRangeLabels: api.metricsRangeDates.map((date) => formatMetricsRangeLabel(date)),
    metricsRangeDates: api.metricsRangeDates,
    isStatusFiltering: api.isStatusFiltering,
    statusMetrics,
    statusTopRow: statusMetrics.slice(0, 2),
    statusBottomRow: statusMetrics.slice(2),
    statusSummary,
    series: {
      executionTrendMetrics: api.series.executionTrendMetrics,
      executionDurationAverage: api.series.executionDurationAverage,
      mttfTrend: api.series.mttfSeconds.map((point) => ({
        label: point.label,
        value: fromSeconds(point.value, 'hours') ?? 0,
      })),
      flakeScoreTrend: api.series.flakeScoreTrend,
      greenTimeTrend: api.series.greenTimeSeconds.map((point) => ({
        label: point.label,
        value: fromSeconds(point.value, 'days') ?? 0,
      })),
      filteredPassRate: api.series.filteredPassRate,
      filteredFailureRate: api.series.filteredFailureRate,
      filteredErrorRate: api.series.filteredErrorRate,
      filteredSkipRate: api.series.filteredSkipRate,
    },
    averages: {
      frequencyPerDay: api.averages.frequencyPerDay,
      flakeScore: api.averages.flakeScore,
      greenTimeDays: fromSeconds(api.averages.greenTimeSeconds, 'days') ?? 0,
      mttfHours: fromSeconds(api.averages.mttfSeconds, 'hours') ?? 0,
      avgDurationSeconds: api.averages.avgDurationSeconds,
    },
  };
};
